<script>
import _ from 'lodash';

import { authComputed, authMethods, clientMethods, trainerComputed } from '@state/helpers';
const appConfig = require('@src/app.config');

export default {
  name: 'SignUpMobile',
  components: {},
  data() {
    return {
      email: '',
      password: '',
      authenticating: false,
    };
  },
  methods: {
    ...authMethods,
    ...clientMethods,
    async handleSignUp() {
      this.authenticating = true;
      const signupData = {
        trainerId: this.myTrainer._id,
        email: this.currentUser.user.email,
        password: this.password,
      };

      const response = await this.signUp(signupData);

      if (response.status === 403) {
        console.error('HandleSignUp Error: ', response);
      } else {
        const updatedUser = _.cloneDeep(this.currentUser);
        updatedUser.user = response.user;
        this.setCurrentUser(updatedUser);

        this.$router.push('/home').catch((err) => {
          if (err !== undefined) {
            console.error(err);
          }
        });
      }

      this.authenticating = false;
    },
  },
  computed: {
    ...authComputed,
    ...trainerComputed,
    validTrainerId() {
      return this.myTrainer && this.myTrainer._id !== undefined;
    },
    validEmail() {
      return this.currentUser.user.email && this.currentUser.user.email !== undefined;
    },
    logoUrl() {
      return appConfig.ORG_ID === '618183d65e84466f63c38878'
        ? 'https://tandem-email.s3.amazonaws.com/pmeo-logo-light.png'
        : 'https://tandem-email.s3.amazonaws.com/smartfitness-logo.png';
    },
  },
};
</script>

<template>
  <div class="container">
    <div class="background">
      <router-link class="to-root" to="/">
        <img svg-inline :src="logoUrl" />
      </router-link>
      <div>
        <h1>Create Account</h1>
        <p>Create an account to get started.</p>
      </div>
    </div>
    <div class="form">
      <form @submit.prevent="handleSignUp">
        <BaseInputText type="email" :disabled="true" classStyle="user" placeholder="Email" v-model="currentUser.user.email" />
        <BaseInputText
          type="password"
          autocomplete
          :disabled="!(myTrainer._id && currentUser.user.email)"
          classStyle="password"
          placeholder="Create Password"
          v-model="password"
        />
        <div class="to-sign-in">
          <p class="have-account">
            Already have an account?
            <router-link class="btn-to-sign-in" to="/login">
              Sign In
            </router-link>
          </p>
        </div>
        <div class="get-started">
          <div class="signup-disabled" v-if="!(myTrainer._id && currentUser.user.email)">
            <h4>Signup Disabled...</h4>
            <pre v-if="!validTrainerId">•Valid TrainerId: {{ validTrainerId }}</pre>
            <pre v-if="!validEmail">•Valid Email: {{ validEmail }}</pre>
          </div>
          <BaseButton
            class="large"
            type="submit"
            :disabled="authenticating || !validTrainerId || !validEmail || password.length < 1"
          >
            <div v-if="authenticating === false">Get Started</div>
            <div v-else><b-spinner /></div>
          </BaseButton>
        </div>
      </form>
      <div class="other-info">
        <p>
          By signing up, you agree to the
          <router-link class="links" to="/privacy">Privacy Policy</router-link>
          and
          <router-link class="links" to="/terms">Terms of Use.</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.container {
  display: flex;
  flex-flow: column;
  height: 100%;
  max-width: unset !important;
  width: 100%;
  .background {
    background: url('~@assets/images/backgrounds/mobile/onboarding-sign-up.svg') no-repeat center center;
    background-position: 0% 0%;
    background-size: cover;
    border: 0;
    display: flex;
    flex: 2 1 auto;
    flex-direction: column;
    justify-content: space-between;
    margin: 0;
    position: relative;
    width: 100%;
    .to-root {
      align-items: center;
      align-self: center;
      display: flex;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
      padding-top: 10.3%;
      width: 47%;
      img {
        align-self: center;
        margin-bottom: auto;
        margin-left: auto;
        margin-right: auto;
        padding-top: 17.3%;
        width: 159.23px;
      }
    }

    h1 {
      color: white;
      font-family: $base-font-family;
      font-size: 35px;
      margin: 0;
      margin-left: 7%;
      margin-top: auto;
      text-align: left;
      white-space: nowrap;
      width: 70%;
    }
    p {
      color: white;
      font-family: $secondary-font-family;
      font-size: 1.5em;
      margin: 0;
      margin-left: 7%;
      margin-top: 0.15%;
      padding-bottom: 4.25%;
      text-align: left;
    }
  }

  .form {
    background: white;
    flex: 0.3 1 auto;
    padding-top: 4rem;
    width: 100%;
    ::v-deep .input-wrapper {
      input {
        border-radius: unset;
      }
    }

    ::v-deep .input-with-label {
      input {
        border-radius: unset;
        margin-bottom: 0;
      }
    }

    .signup-disabled {
      margin-top: 10px;
    }

    .to-sign-in {
      font-family: $secondary-font-family;
      margin: 5px 10% auto auto;
      padding-bottom: 10%;
      text-align: end;
      .have-account {
        white-space: nowrap;
      }
      .btn-to-sign-in {
        color: #4059e1;
        text-decoration: none;
      }
    }

    .get-started {
      align-self: flex-end;
      margin-left: 6.4%;
      width: 87.2%;

      button:disabled {
        background-color: lighten($color: #4059e1, $amount: 20);
      }
    }
  }

  .other-info {
    display: flex;
    height: 25%;
    justify-content: center;
    padding-top: 10px;
    width: 100%;

    p {
      font-family: $secondary-font-family;
      height: 100%;
      line-height: 1.4;
      text-align: center;
      width: 82%;

      .links {
        color: #4059e1;
        text-decoration: none;
      }
    }
  }
}
</style>
